// © Microsoft Corporation. All rights reserved.

/**
 * Default key value for looking up experience instances
 */
export const defaultInstanceKeyName = "default";

/**
 * Default time value for start/end time
 */
export const defaultTimeValue = -1;
